"use strict";
/** @jsxRuntime classic */
/** @jsx jsx */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieDeclarationBanner = exports.COOKIE_DECLARATION_BANNER_ID = void 0;
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
var Button_1 = require("../../atoms/Button/Button");
var utils_1 = require("../../atoms/ConfirmationInput/utils");
var LabeledCheckbox_1 = require("../../molecules/LabeledCheckbox/LabeledCheckbox");
var useCookieDeclaration_1 = require("./context/useCookieDeclaration");
exports.COOKIE_DECLARATION_BANNER_ID = "cookie-declaration-form";
// This component is using a lot of styles from the updated design, which will be merged in in the future.
// Due to this, a lot of the styles are fixed and don't use a theme
// TODO: refactor this using new styles from the theme
/**
 * Note: this component must be used with a CookieDeclarationProvider, which manages it's state.
 * This component is used for the actual form that user submits
 *
 * @see CookieDeclarationProvider
 */
var CookieDeclarationBanner = function (_a) {
    var cookiePolicyLink = _a.cookiePolicyLink;
    var t = react_i18next_1.useTranslation("jds").t;
    var cookieDeclaration = useCookieDeclaration_1.useCookieDeclaration();
    var _b = react_1.useState(cookieDeclaration.consentState), preferences = _b[0], setPreference = _b[1];
    var createUpdateHandler = function (preferenceName) { return function (event) {
        var _a;
        return setPreference(__assign(__assign({}, preferences), (_a = {}, _a[preferenceName] = event.target.checked, _a)));
    }; };
    var onAcceptAll = react_1.useCallback(function () {
        cookieDeclaration.updateDeclaration({
            marketing: true,
            analytics: true,
            personalisation: true,
        });
        setPreference({
            marketing: true,
            analytics: true,
            personalisation: true,
        });
        cookieDeclaration.close();
    }, [cookieDeclaration]);
    var onAcceptSelected = react_1.useCallback(function () {
        cookieDeclaration.updateDeclaration(preferences);
        cookieDeclaration.close();
    }, [cookieDeclaration, preferences]);
    var preferenceNames = Object.keys(preferences);
    return cookieDeclaration.isOpen ? (theme_ui_1.jsx(theme_ui_1.Box, { sx: {
            position: "relative",
            zIndex: 999,
            p: [4, 4, 4, theme_1.theme.space[4] + "px 85px"],
            backgroundColor: "#080F1E",
        }, role: "banner", ref: cookieDeclaration.ref },
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                flexDirection: ["column", "column", "column", "row"],
                justifyContent: "space-between",
            } },
            theme_ui_1.jsx(theme_ui_1.Box, { sx: { mr: 2 } },
                theme_ui_1.jsx(theme_ui_1.Box, { sx: { maxWidth: "930px", mb: 3 } },
                    theme_ui_1.jsx(theme_ui_1.Text, { sx: { mb: 1 }, as: "h5", variant: "h5" }, t("cookiesDeclaration:title", "Cookies")),
                    theme_ui_1.jsx(theme_ui_1.Text, { as: "p", sx: { fontSize: "16px" } },
                        t("cookiesDeclaration:textStart", "We use cookies and similar technologies to make this site work. You can choose what kinds of cookies you want us to set or accept all types below. Our"),
                        " ",
                        theme_ui_1.jsx(theme_ui_1.Link, { rel: "noopener", href: cookiePolicyLink, target: "_blank" }, t("cookiesDeclaration:cookiePolicyLink", "Cookie Policy")),
                        " ",
                        t("cookiesDeclaration:textEnd", "explains more about the cookies we use and allows you to change your settings at any time."))),
                theme_ui_1.jsx(theme_ui_1.Flex, { sx: { flexWrap: "wrap", maxWidth: "600px" } },
                    theme_ui_1.jsx(LabeledCheckbox_1.LabeledCheckbox, { lsx: { width: "auto", flex: "1 0 150px", mr: 0 }, checked: true, disabled: true, onChange: utils_1.noop, id: "cookie-declaration-form-necessary-checkbox" },
                        theme_ui_1.jsx(theme_ui_1.Text, { as: "p", variant: "text.small" }, t("cookiesDeclaration:checkBox:necessary", "Necessary"))),
                    preferenceNames.map(function (preference) { return (theme_ui_1.jsx(LabeledCheckbox_1.LabeledCheckbox, { lsx: {
                            width: "auto",
                            flex: "1 0 150px",
                            mr: 0,
                        }, onChange: createUpdateHandler(preference), checked: preferences[preference], id: "cookie-declaration-form-" + preference + "-checkbox", key: preference },
                        theme_ui_1.jsx(theme_ui_1.Text, { as: "p", variant: "text.small" }, t(PREFERENCE_DISPLAY_NAMES_TRANSLATIONS[preference], PREFERENCE_DISPLAY_NAMES[preference])))); }))),
            theme_ui_1.jsx(theme_ui_1.Flex, { sx: { flexDirection: ["column", "row", "row", "column"] } },
                theme_ui_1.jsx(Button_1.Button, { onClick: onAcceptSelected, csx: {
                        background: "#374156",
                        borderRadius: 2,
                        fontWeight: theme_1.theme.fontWeights.light,
                        mt: 2,
                        mr: [0, 2, 2, 0],
                    }, id: exports.COOKIE_DECLARATION_BANNER_ID + "-accept-selected-button" }, t("cookiesDeclaration:button:acceptSelected", "Accept Selected")),
                theme_ui_1.jsx(Button_1.Button, { onClick: onAcceptAll, csx: {
                        background: "#1CE5B6",
                        borderRadius: 2,
                        fontWeight: theme_1.theme.fontWeights.bold,
                        color: theme_1.theme.colors.jagexBlack,
                        mt: 2,
                    }, id: exports.COOKIE_DECLARATION_BANNER_ID + "-accept-all-button" }, t("cookiesDeclaration:button:acceptAll", "Accept All")))))) : null;
};
exports.CookieDeclarationBanner = CookieDeclarationBanner;
var PREFERENCE_DISPLAY_NAMES = {
    personalisation: "Personalisation",
    analytics: "Analytics",
    marketing: "Marketing",
};
var PREFERENCE_DISPLAY_NAMES_TRANSLATIONS = {
    personalisation: "cookiesDeclaration:checkBox:personalisation",
    analytics: "cookiesDeclaration:checkBox:analytics",
    marketing: "cookiesDeclaration:checkBox:marketing",
};
